import { segmentLabelForChartTitle } from '../../PageConfigProvider/constants';
import type { SecondaryDimensionValues } from '../../PageConfigProvider/types/dimension';
import type { PositionedItem } from '../../PageConfigProvider/types/item';

export const getSegmentForChartTitle = (
  item: PositionedItem | undefined
): string | undefined => {
  const effectiveDimensionSource = item?.plot?.dimensionSource;

  if (
    !effectiveDimensionSource ||
    effectiveDimensionSource === 'primary' ||
    !(effectiveDimensionSource in segmentLabelForChartTitle)
  ) {
    return undefined;
  }
  return segmentLabelForChartTitle[
    effectiveDimensionSource as SecondaryDimensionValues
  ];
};
